import { matchPath, useLocation } from "react-router-dom";

import { getRedirectAuthenticatedUserToLocation } from "features/sign-up/global-sign-up-modal/links";

export function useGetRedirectAuthenticatedUserToLocationMatches(
  pathname: string
) {
  const location = useLocation();

  const redirectAuthUserTo = getRedirectAuthenticatedUserToLocation(location);

  if (!redirectAuthUserTo) {
    return false;
  }

  const redirectLink =
    typeof redirectAuthUserTo === "string"
      ? redirectAuthUserTo
      : redirectAuthUserTo.pathname;

  return !!matchPath(redirectLink, {
    path: pathname
  });
}
